export const educationPricingResolvedQuery = groq`*[
  _type == "educationPricing" && currentPathname == $currentPathname
][0].plans {
  ...,
  plans[] {
    ...,
    "resolvedPlan": selectPlan.reference->,
    "resolvedPlanPrices": selectPlan.reference->price.reference->variations[] {
      "name": personalizationVariant,
      "value": sectionBuilder.sectionBuilder[_type == "sectionBuilderPortableText"][0].sectionBuilderPortableText[0].children[0].text
    }
  }
}`;
